import {Canvas, DPI} from './Canvas'
import {randomItem} from '../../../../utils'

const COLOR: string = randomItem(['#006699', '#ee374d', '#006699', '#ee374d', '#2b2b2b'])

export class JacketPainter extends Canvas {
    constructor(width: number, height: number) {
        super(width, height)
        this.draw()
    }

    public getCanvas(): HTMLCanvasElement {
        return this.canvas
    }

    private draw(): void {
        const ctx = this.ctx
        ctx.fillStyle = '#ffffff'
        const {width, height} = this.size()
        ctx.fillRect(0, 0, width, height)
        this.fractal(ctx, 7)
        this.fractal(ctx, -7)
        ctx.lineWidth = 10 * DPI
        ctx.strokeStyle = '#f8f8f8'
        ctx.strokeRect(0, 0, width, height)
    }

    private fractal(ctx: CanvasRenderingContext2D, angle: number): void {
        const {width, height} = this.size()
        const x = Math.round(width / 2)
        const y = Math.round(height / 2)
        ctx.strokeStyle = COLOR
        ctx.lineWidth = (window.innerWidth < 500 ? 1 : 2) * DPI

        for (let i = 0, size = 4 * DPI, step = 4 * DPI; i < 50; i++) {
            ctx.save()
            ctx.translate(x, y)
            ctx.rotate((angle * i * Math.PI) / 180)
            ctx.strokeRect(-size / 2, -size / 2, size, size)
            ctx.restore()
            size += step
        }
    }
}
